import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=2650be8f&scoped=true"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"
import style0 from "./Carousel.css?vue&type=style&index=0&id=2650be8f&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2650be8f",
  null
  
)

export default component.exports